// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { BarcodePrintStatusEnum } from './enums';
import { ItemDetailStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ItemDetailHist extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** String(12) key */
  id!: string;
  /** Int32 */
  accountId?: number;
  /** String(10) */
  accountPurchaseInvoiceHeaderId?: string;
  /** Int32 */
  accountPurchaseJoDetailId?: number;
  /** Enum */
  barcodePrintStatusId!: BarcodePrintStatusEnum;
  /** DateTimeOffset */
  crtnTs?: Date;
  /** String(10) */
  invoiceHeaderId?: string;
  /** Int32 */
  itemBinId!: number;
  /** Enum */
  itemDetailStatusId!: ItemDetailStatusEnum;
  /** Int32 */
  joDetailId?: number;
  /** DateTimeOffset */
  lastScanTs?: Date;
  /** Int32 */
  poDetailId?: number;
  /** Int32 */
  poTrxId?: number;
  /** Int32 */
  productId!: number;
  /** Binary */
  rowVersion!: any;
  /** Int32 */
  shipBinId?: number;
}

